import { render, staticRenderFns } from "./SocialsForm.vue?vue&type=template&id=3ee1d6c0"
import script from "./SocialsForm.vue?vue&type=script&lang=js"
export * from "./SocialsForm.vue?vue&type=script&lang=js"
import style0 from "./SocialsForm.vue?vue&type=style&index=0&id=3ee1d6c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports